export default "__VITE_ASSET__DiQpM9s1__"